<template>
  <div class="modal-body">
    <div class="registration-errors" v-show="errorMessage">
      <div class="alert alert-danger">{{ errorMessage }}</div>
    </div>

    <!-- Registration Disabled -->
    <div class="text-center" v-if="conference?.registration_disabled">
      <h5 class="m-t-100">Registration for this event is closed</h5>

      <div class="m-t-30">
        <svg width="69" height="69" viewBox="0 0 69 69" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M50.3641 29.1356V15.8715C50.3641 7.11874 43.241 0 34.4941 0C25.7517 0 18.6359 7.11874 18.6359 15.8715V29.14C14.1861 33.3505 11.3938 39.2962 11.3938 45.8953C11.3938 58.6397 21.7585 69 34.5 69C47.2415 69 57.6062 58.6383 57.6062 45.8953C57.6062 39.2948 54.8153 33.3461 50.3641 29.1356ZM24.2939 15.87C24.2939 10.237 28.8714 5.65213 34.4941 5.65213C40.1257 5.65213 44.7047 10.237 44.7047 15.87V25.1923C41.6173 23.6699 38.1687 22.7891 34.5015 22.7891C30.8312 22.7891 27.3754 23.6714 24.2939 25.1967V15.87ZM34.5015 60.5761C26.405 60.5761 19.8235 53.9932 19.8235 45.8953C19.8235 37.7988 26.405 31.2174 34.5015 31.2174C42.5994 31.2174 49.1794 37.7988 49.1794 45.8953C49.1794 53.9918 42.5994 60.5761 34.5015 60.5761Z" fill="#626264"/>
          <path d="M25.6018 39.672L34.5894 51.079L46.1535 36.8621L34.5894 44.7369L25.6018 39.672Z" fill="#626264"/>
        </svg>
      </div>
    </div>

    <h4 v-if="conference.id === 5965" class="membership-title in-person-type-title">In-Person (Face to Face)</h4>

    <!-- In-Person Tickets -->
    <h4
      v-if="tickets.inperson.length && tickets.virtual.length"
      class="membership-title in-person-type-title"
    >In-Person <i class="fa-regular fa-user default-color"></i></h4>

    <fragment v-for="(ticket, index) in tickets.inperson" :key="`inperson-${index}`">
      <ticket
        type="inperson"
        :ticket="ticket"
        :index="index"
        :donation.sync="donation"
      />
    </fragment>


    <!-- Virtual Tickets -->
    <h4
      v-if="tickets.inperson.length && tickets.virtual.length"
      class="membership-title live-streamed-type-title"
    >Live-Streamed <i class="fa-regular icon-globe default-color"></i></h4>

    <fragment v-for="(ticket, index) in tickets.virtual" :key="`virtual-${index}`">
      <ticket
        type="virtual"
        :ticket="ticket"
        :index="index"
        :donation.sync="donation"
      />
    </fragment>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Ticket from "./Ticket.vue";

export default {
  components: {
    Ticket
  },
  computed: {
    ...mapGetters("basketStore", [
      "conference",
      "tickets",
      "errorMessage"
    ])
  }
}
</script>

<style lang="scss" scoped>
</style>
